class loadHelper {

    constructor() {

        var _this = this;

        var i = 0;

        window.addEventListener("load", function() {
            $(".klg__scroll-listener").each(function () {
                i++;
                _this.checkFade($(this), 'init', i);
            });
        });
    }

    listen() {

        var _this = this;
        var i = 0;
        window.addEventListener("scroll", function(){
            i++;

            $(".klg__scroll-listener").each(function(){
                _this.checkFade($(this), 'scroll', i);
            });
        });

    }

    checkFade(e, when, count) {

        if(when === 'init' && count === 1) {
            e.addClass('in');
            return;
        }

        var windowBottom = $(window).scrollTop() + $(window).innerHeight();

        let offset = e[0].offsetHeight - $(e).data('scroll-offset');
        var objectBottom = e.offset().top + offset;

        if (objectBottom < windowBottom) {
            e.addClass('in');
            if (e.hasClass('in') === false) {
                e.addClass('in');
            }
        }
    }
}

window.app.add('load', new loadHelper());